
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { UserItemProps } from ".";
import { loading, endLoading } from "store/user";

interface ApiUserRemoveInputProps {
    ids: number[]
}

type ApiUserRemoveOutputProps = OutputBaseProps<{ item: UserItemProps; }>

export const apiUserRemove = async (data: ApiUserRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiUserRemoveOutputProps>("/api/user/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};